import { useEffect, useState } from "react";

const BAR_W = 24;
const hex = () => Math.floor(Math.random() * 256).toString(16).toUpperCase().padStart(2, "0");
const dumpRows = () =>
  Array.from({ length: 12 }, (_, i) =>
    `0x${(0xa400 + i * 16 + Math.floor(Math.random() * 4096)).toString(16).toUpperCase()}  ${Array.from({ length: 8 }, hex).join(" ")}`,
  );

function Bar({ label, value }) {
  const v = Math.max(0, Math.min(1, value));
  const fill = Math.round(v * BAR_W);
  const glow = { textShadow: `0 0 ${4 + v * 18}px rgba(0, 255, 210, ${0.3 + v * 0.6})` };
  return (
    <div className="boot-bar" data-testid="boot-progress-bar">
      <span className="boot-bar-label">{label}</span>
      <span style={glow}>{"█".repeat(fill)}<span className="boot-bar-empty">{"░".repeat(BAR_W - fill)}</span></span>
      <span className="boot-bar-pct">{Math.round(v * 100)}%</span>
    </div>
  );
}

export function BootBars({ progress: p }) {
  return (
    <div className="boot-bars">
      <Bar label="TRANSLATOR CORE" value={p * 1.7} />
      <Bar label="MYCELIAL BANDS" value={(p - 0.12) * 1.5} />
      <Bar label="SIGNAL DECRYPT" value={p < 0.97 ? Math.pow(p, 1.6) * 0.95 : 1} />
      <Bar label="SPORE DENSITY" value={0.35 + p * 0.6} />
    </div>
  );
}

export function HexDump({ running }) {
  const [rows, setRows] = useState(dumpRows);
  useEffect(() => {
    if (!running) return;
    const t = setInterval(() => setRows(dumpRows()), 110);
    return () => clearInterval(t);
  }, [running]);
  return (
    <pre className="boot-hex" data-testid="boot-hex-dump">
      {rows.join("\n")}
    </pre>
  );
}
